<template>
    <div class="pending-invoices-card">
        <el-card>
            <div class="pending-invoices-card_content">
                <div class="content_totalizer">{{ pendingNotes }}</div>
                <div class="content_text">{{ translate('pending_transactions') }}</div>
                <div
                    class="content_action"
                    @click="goToPendingInvoices"
                >
                    {{ translate('view_notes') }}
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'ViewPendingInvoicesCard',
    components: {
    },
    props: {
        pendingNotes: {
            type: Number,
            required: true,
            default: 0
        }
    },
    data() {
        return {
            searchText: ''
        };
    },
    computed: {
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse.messages';
            return this.$tc(`${base}.${key}`, params);
        },
        goToPendingInvoices() {
            this.$router.push({
                name: 'VisualizarArmazem',
                params: {
                    warehouseId: null,
                    viewPendingOperations: 'transacoes-pendentes'
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
.pending-invoices-card {
    margin-bottom: 16px;
    border: 1px solid #359138 !important;
    border-left: 5px solid #359138 !important;
    border-radius: 5px;

    .pending-invoices-card_content {
        display: flex;
        gap: 8px;

        .content_totalizer {
            font-size: 22px;
            font-weight: 500;
        }
        .content_text {
            font-weight: 500;
            margin-top: 6px;
        }
        .content_action {
            font-weight: 500;
            margin-top: 6px;
            color: #2284DD;
            text-decoration: underline;
            cursor: pointer;
        }
    }
}
</style>
